import React from 'react';
import { PropTypes } from 'prop-types';
import {
  deliveryNotesFileExtensionsButton,
  laboratoryFileExtensionsButton,
} from '../../constants/general';
import styles from './index.module.scss';

const AccionaBigUploadButton = ({ onClick, msg, icon, type }) => (
  <div className={`home-button ${styles.wrapper} ${icon}`}>
    {/* eslint-disable-next-line*/}
    <a
      className="home-button"
      onClick={() => fileUploadHandler(icon)}
      id="AccionaBigUploadButton"
    >
      <div className="image-btn"> </div>
      <input
        accept={
          type === 'deliveryNote'
            ? deliveryNotesFileExtensionsButton
            : laboratoryFileExtensionsButton
        }
        hidden
        id={`fileSelector_${icon}`}
        type="file"
        onChange={onClick}
        multiple="multiple"
      />
      <span> {msg}</span>
    </a>
  </div>
);

const fileUploadHandler = (icon) => {
  document.getElementById(`fileSelector_${icon}`).click();
};

AccionaBigUploadButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  msg: PropTypes.string,
  icon: PropTypes.string,
  type: PropTypes.oneOf(['deliveryNote', 'laboratory']).isRequired,
};

AccionaBigUploadButton.defaultProps = {
  onClick: () => {},
  msg: 'UPLOAD',
  icon: 'data',
};

export default AccionaBigUploadButton;
